var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame480959981(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 3.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 3.75,
    stroke: "#173C19",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29829_42235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29829_42235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 28.25C24.7 28.25 23.8125 27.8875 23.0875 27.1625C22.3625 26.4375 22 25.55 22 24.5C22 23.45 22.3625 22.5625 23.0875 21.8375C23.8125 21.1125 24.7 20.75 25.75 20.75C26.8 20.75 27.6875 21.1125 28.4125 21.8375C29.1375 22.5625 29.5 23.45 29.5 24.5C29.5 25.55 29.1375 26.4375 28.4125 27.1625C27.6875 27.8875 26.8 28.25 25.75 28.25ZM25.75 26.25C26.2333 26.25 26.6458 26.0792 26.9875 25.7375C27.3292 25.3958 27.5 24.9833 27.5 24.5C27.5 24.0167 27.3292 23.6042 26.9875 23.2625C26.6458 22.9208 26.2333 22.75 25.75 22.75C25.2667 22.75 24.8542 22.9208 24.5125 23.2625C24.1708 23.6042 24 24.0167 24 24.5C24 24.9833 24.1708 25.3958 24.5125 25.7375C24.8542 26.0792 25.2667 26.25 25.75 26.25ZM12 25.5V23.5H20V25.5H12ZM14.25 19.25C13.2 19.25 12.3125 18.8875 11.5875 18.1625C10.8625 17.4375 10.5 16.55 10.5 15.5C10.5 14.45 10.8625 13.5625 11.5875 12.8375C12.3125 12.1125 13.2 11.75 14.25 11.75C15.3 11.75 16.1875 12.1125 16.9125 12.8375C17.6375 13.5625 18 14.45 18 15.5C18 16.55 17.6375 17.4375 16.9125 18.1625C16.1875 18.8875 15.3 19.25 14.25 19.25ZM14.25 17.25C14.7333 17.25 15.1458 17.0792 15.4875 16.7375C15.8292 16.3958 16 15.9833 16 15.5C16 15.0167 15.8292 14.6042 15.4875 14.2625C15.1458 13.9208 14.7333 13.75 14.25 13.75C13.7667 13.75 13.3542 13.9208 13.0125 14.2625C12.6708 14.6042 12.5 15.0167 12.5 15.5C12.5 15.9833 12.6708 16.3958 13.0125 16.7375C13.3542 17.0792 13.7667 17.25 14.25 17.25ZM20 16.5V14.5H28V16.5H20Z",
    fill: "#173C19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame480959981);
export default __webpack_public_path__ + "static/media/Frame 48095998 (1).f032384ea3136d6d5b2479d91b990783.svg";
export { ForwardRef as ReactComponent };